var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createPrintingRecord" },
    [
      _c(
        "div",
        { staticClass: "update-info-new" },
        [
          _vm.drawerParams.is_getApi === "1"
            ? [
                _vm.customer_info.customer_id != 0
                  ? _c(
                      "el-card",
                      {
                        staticClass: "box-card",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: { shadow: "never" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c("span", { staticClass: "title__style-color" }, [
                              _vm._v("客户信息"),
                            ]),
                          ]
                        ),
                        _vm.customer_info.customer_id == 0
                          ? _c("div", { staticClass: "emptyTip" }, [
                              _vm._v(" 暂无客户信息 "),
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("客户名称："),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "topInfoValue" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { padding: "0" },
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.jumpCustomerList(
                                                _vm.customer_info
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.customer_info.customer_id ||
                                                  ""
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.customer_info.company_name || ""
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("销售姓名："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(_vm.customer_info.username || "")
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("所属部门："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customer_info.organize_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("公海："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customer_info.high_seas_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("成交状态："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customer_info.deal_status_des || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("规模："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(_vm.customer_info.scale_des || "")
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                      ]
                    )
                  : _vm._e(),
                _vm.project_delivery_info.project_delivery_id != 0
                  ? _c(
                      "el-card",
                      {
                        staticClass: "box-card",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: { shadow: "never" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c("span", { staticClass: "title__style-color" }, [
                              _vm._v("设计工单"),
                            ]),
                          ]
                        ),
                        _vm.project_delivery_info.project_delivery_id == 0
                          ? _c("div", { staticClass: "emptyTip" }, [
                              _vm._v(" 未关联设计工单 "),
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c(
                                  "div",
                                  { staticClass: "topInfoItem" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "topInfoLabel" },
                                      [_vm._v("任务ID：")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { padding: "0" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewProjectDetail()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.project_delivery_info
                                              .project_delivery_id || ""
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("订单业务类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project_delivery_info
                                          .card_bin_group_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("卡类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project_delivery_info
                                          .card_bin_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v(" 套（卡/券/礼包券套）： "),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project_delivery_info
                                          .need_card_coupon_sleeve || ""
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("设计产品类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project_delivery_info
                                          .design_product_type_des || ""
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "topInfoItem topInfoItem--block",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "topInfoLabel" },
                                      [_vm._v("设计稿：")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "topInfoValue" },
                                      [
                                        _vm.project_delivery_info
                                          .design_draft &&
                                        Array.isArray(
                                          _vm.project_delivery_info.design_draft
                                        ) &&
                                        _vm.project_delivery_info.design_draft
                                          .length
                                          ? [
                                              _vm.project_delivery_info.design_draft.some(
                                                function (item) {
                                                  return _vm.isDesignImage(item)
                                                }
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "img-style2",
                                                    },
                                                    _vm._l(
                                                      _vm.project_delivery_info.design_draft.filter(
                                                        function (el) {
                                                          return _vm.isDesignImage(
                                                            el
                                                          )
                                                        }
                                                      ),
                                                      function (item, idx) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              "delivery-img-" +
                                                              idx,
                                                            staticClass:
                                                              "img-style2-con",
                                                          },
                                                          [
                                                            _c("el-image", {
                                                              staticStyle: {
                                                                height: "50px",
                                                                width: "70px",
                                                              },
                                                              attrs: {
                                                                src: _vm.getDesignImgUrl(
                                                                  item
                                                                ),
                                                                fit: "cover",
                                                                "preview-src-list":
                                                                  _vm.project_delivery_info.design_draft
                                                                    .filter(
                                                                      function (
                                                                        el
                                                                      ) {
                                                                        return _vm.isDesignImage(
                                                                          el
                                                                        )
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        el
                                                                      ) {
                                                                        return _vm.getDesignImgUrl(
                                                                          el
                                                                        )
                                                                      }
                                                                    ),
                                                              },
                                                            }),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-download download-icon",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.downloadDesignFile(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _vm.project_delivery_info.design_draft.some(
                                                function (item) {
                                                  return !_vm.isDesignImage(
                                                    item
                                                  )
                                                }
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "file-list",
                                                    },
                                                    _vm._l(
                                                      _vm.project_delivery_info.design_draft.filter(
                                                        function (el) {
                                                          return !_vm.isDesignImage(
                                                            el
                                                          )
                                                        }
                                                      ),
                                                      function (item, idx) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key:
                                                              "delivery-file-" +
                                                              idx,
                                                            staticClass:
                                                              "file-item",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "file-info",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-document file-icon",
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "file-name",
                                                                    class: {
                                                                      "pdf-file":
                                                                        _vm.isImage(
                                                                          _vm.getDesignFileName(
                                                                            item
                                                                          )
                                                                        ) ===
                                                                          false &&
                                                                        /\.(pdf)$/i.test(
                                                                          _vm.getDesignFileName(
                                                                            item
                                                                          )
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          ;/\.(pdf)$/i.test(
                                                                            _vm.getDesignFileName(
                                                                              item
                                                                            )
                                                                          ) &&
                                                                            _vm.openFile(
                                                                              _vm.getDesignFileUrl(
                                                                                item
                                                                              )
                                                                            )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getDesignFileName(
                                                                          item
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-download file-download-icon",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.downloadDesignFile(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _c("span", [_vm._v("--")]),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                      ]
                    )
                  : _vm._e(),
                _vm.card_make_info.card_make_id != 0
                  ? _c(
                      "el-card",
                      {
                        staticClass: "box-card",
                        staticStyle: { "margin-bottom": "10px" },
                        attrs: { shadow: "never" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c("span", { staticClass: "title__style-color" }, [
                              _vm._v("制卡信息"),
                            ]),
                          ]
                        ),
                        _vm.card_make_info.card_make_id == 0
                          ? _c("div", { staticClass: "emptyTip" }, [
                              _vm._v(" 暂无制卡信息 "),
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("批次号："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(_vm.card_make_info.batch || "")
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("订单业务类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info
                                          .card_bin_group_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("卡类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info.card_bin_name || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("卡用途："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info.purpose_des || ""
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "topInfoRow" }, [
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("所属分公司："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info.branch_office_name ||
                                          ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("制卡总数："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info.make_count || ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("物料类型："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.card_make_info.material_type_des ||
                                          ""
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "topInfoItem" }, [
                                  _c("span", { staticClass: "topInfoLabel" }, [
                                    _vm._v("备注："),
                                  ]),
                                  _c("span", { staticClass: "topInfoValue" }, [
                                    _vm._v(
                                      _vm._s(_vm.card_make_info.note || "")
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("印刷信息"),
                  ]),
                ]
              ),
              _c(
                "el-form",
                {
                  ref: "printForm",
                  attrs: { model: _vm.printInfo, inline: "" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "topInfoRow" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "印刷类型",
                            prop: "print_type",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择印刷类型",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "请选择",
                                size: "small",
                                clearable: "",
                                disabled:
                                  _vm.print_type_disabled ||
                                  _vm.material_apply__disabled,
                              },
                              on: { change: _vm.onPrintTypeChange },
                              model: {
                                value: _vm.printInfo.print_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.printInfo, "print_type", $$v)
                                },
                                expression: "printInfo.print_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { value: "1", label: "标准版" },
                              }),
                              _c("el-option", {
                                attrs: { value: "2", label: "个性化" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "供应商",
                            prop: "supplier_id",
                            "label-width": "130px",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择供应商",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "260px" },
                              attrs: {
                                placeholder: "请选择",
                                size: "small",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.printInfo.supplier_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.printInfo, "supplier_id", $$v)
                                },
                                expression: "printInfo.supplier_id",
                              },
                            },
                            _vm._l(_vm.supplierList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.supplier_name,
                                  value: String(item.id),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "130px",
                            label: "是否加急",
                            prop: "is_urgent",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择是否加急",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.printInfo.is_urgent,
                                callback: function ($$v) {
                                  _vm.$set(_vm.printInfo, "is_urgent", $$v)
                                },
                                expression: "printInfo.is_urgent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("是"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.printInfo.print_type === "2"
                    ? _c(
                        "div",
                        { staticClass: "topInfoRow" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "关联客户",
                                prop: "customer_id",
                                rules: [
                                  {
                                    required: true,
                                    trigger: "change",
                                    message: "请选择关联客户",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    placeholder: "请选择关联客户",
                                    "remote-method": _vm.getCustomerList,
                                    size: "small",
                                  },
                                  on: {
                                    clear: _vm.clearCustomer,
                                    change: _vm.changeCustomer,
                                  },
                                  model: {
                                    value: _vm.printInfo.customer_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.printInfo,
                                        "customer_id",
                                        $$v
                                      )
                                    },
                                    expression: "printInfo.customer_id",
                                  },
                                },
                                _vm._l(_vm.CustomerList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.customer_name,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售负责人",
                                prop: "sale_user_id",
                                "label-width": "130px",
                                rules: [
                                  {
                                    required: true,
                                    trigger: "change",
                                    message: "销售负责人不能为空",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "260px" },
                                  attrs: {
                                    size: "small",
                                    filterable: "",
                                    placeholder: "请选择销售负责人",
                                  },
                                  model: {
                                    value: _vm.printInfo.sale_user_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.printInfo,
                                        "sale_user_id",
                                        $$v
                                      )
                                    },
                                    expression: "printInfo.sale_user_id",
                                  },
                                },
                                _vm._l(_vm.sellUserList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("物料明细"),
                  ]),
                  !_vm.material_apply__disabled
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.openAddMaterialDialog },
                        },
                        [_vm._v("添加物料")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              !_vm.material_arr || _vm.material_arr.length === 0
                ? _c("div", { staticClass: "emptyTip" }, [_vm._v(" 暂无物料 ")])
                : _c(
                    "el-form",
                    {
                      ref: "materialForm",
                      staticClass: "material-form",
                      attrs: { model: _vm.materialFormData },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            "header-cell-style": {
                              background: "#F1F1F1",
                              color: "#333333",
                            },
                            data: _vm.material_arr,
                            "row-key": "material_id",
                            "expand-row-keys": _vm.expandedRowKeys,
                            "tooltip-effect": "dark",
                          },
                          on: { "expand-change": _vm.handleExpandChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "expand", width: "48" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "10px 20px 10px 40px",
                                        },
                                      },
                                      [
                                        _vm.printInfo.print_type === "1" &&
                                        !["1", "2"].includes(
                                          String(scope.row.material_type)
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "10px",
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      padding: "0",
                                                      color: "#367fa9",
                                                    },
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addMaterialBranch(
                                                          scope.$index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" + 添加入库仓库 ")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !scope.row.branch_office_data ||
                                        scope.row.branch_office_data.length ===
                                          0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "emptyTip",
                                                staticStyle: {
                                                  padding: "10px 0",
                                                },
                                              },
                                              [_vm._v(" 暂无分公司/仓库分配 ")]
                                            )
                                          : _c(
                                              "el-table",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  border: "",
                                                  size: "small",
                                                  "header-cell-style": {
                                                    background: "#F8F8F8",
                                                    color: "#333333",
                                                  },
                                                  data: scope.row
                                                    .branch_office_data,
                                                  "tooltip-effect": "dark",
                                                  "show-summary":
                                                    scope.row
                                                      .branch_office_data &&
                                                    scope.row.branch_office_data
                                                      .length > 0,
                                                  "summary-method":
                                                    _vm.getBranchOfficeSummary,
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "index",
                                                    label: "序号",
                                                    width: "60",
                                                    align: "center",
                                                  },
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "分公司/仓库",
                                                    "min-width": "180",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (inner) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "cell-form-item",
                                                                attrs: {
                                                                  prop:
                                                                    "material_arr." +
                                                                    scope.$index +
                                                                    ".branch_office_data." +
                                                                    inner.$index +
                                                                    ".branch_office_id",
                                                                  rules: {
                                                                    required: true,
                                                                    message:
                                                                      "请选择分公司/仓库",
                                                                    trigger:
                                                                      "change",
                                                                  },
                                                                  "label-width":
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-select",
                                                                  {
                                                                    staticClass:
                                                                      "input__width",
                                                                    attrs: {
                                                                      placeholder:
                                                                        "请选择",
                                                                      filterable:
                                                                        "",
                                                                      disabled:
                                                                        _vm.is_card_disabled ||
                                                                        String(
                                                                          inner
                                                                            .row
                                                                            .from_summary
                                                                        ) ===
                                                                          "1",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.changeMaterialBranch(
                                                                            scope.$index,
                                                                            inner.row
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        inner
                                                                          .row
                                                                          .branch_office_id,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            inner.row,
                                                                            "branch_office_id",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "inner.row.branch_office_id",
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    scope.row
                                                                      .branch_office_select,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "el-option",
                                                                        {
                                                                          key: item.id,
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                item.name,
                                                                              value:
                                                                                item.id,
                                                                              disabled:
                                                                                _vm.isBranchOfficeSelected(
                                                                                  scope.$index,
                                                                                  inner.$index,
                                                                                  item.id
                                                                                ),
                                                                            },
                                                                        }
                                                                      )
                                                                    }
                                                                  ),
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "起始卡序号",
                                                    "min-width": "140",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (inner) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  inner.row
                                                                    .begin_code ||
                                                                    "-"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "结束卡序号",
                                                    "min-width": "140",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (inner) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  inner.row
                                                                    .end_code ||
                                                                    "-"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm.hasFromSummary
                                                  ? _c("el-table-column", {
                                                      attrs: {
                                                        label: "申请制作数量",
                                                        width: "110",
                                                        align: "center",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              inner
                                                            ) {
                                                              return [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      inner.row
                                                                        .apply_quantity ||
                                                                        "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                                _vm.hasFromSummary
                                                  ? _c("el-table-column", {
                                                      attrs: {
                                                        label: "拟印刷数量",
                                                        width: "110",
                                                        align: "center",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              inner
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "cell-form-item",
                                                                    attrs: {
                                                                      prop:
                                                                        "material_arr." +
                                                                        scope.$index +
                                                                        ".branch_office_data." +
                                                                        inner.$index +
                                                                        ".planned_print_quantity",
                                                                      rules: [
                                                                        {
                                                                          required: true,
                                                                          message:
                                                                            "请输入拟印刷数量",
                                                                          trigger:
                                                                            "blur",
                                                                        },
                                                                        {
                                                                          pattern:
                                                                            /^([1-9]\d*)$/,
                                                                          message:
                                                                            "请输入正整数",
                                                                          trigger:
                                                                            "blur",
                                                                        },
                                                                      ],
                                                                      "label-width":
                                                                        "0",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          inner
                                                                            .row
                                                                            .planned_print_quantity ||
                                                                            "-"
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "印刷数量",
                                                    "min-width": "120",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (inner) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "cell-form-item",
                                                                attrs: {
                                                                  prop:
                                                                    "material_arr." +
                                                                    scope.$index +
                                                                    ".branch_office_data." +
                                                                    inner.$index +
                                                                    ".make_count",
                                                                  rules: [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "请输入印刷数量",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                    {
                                                                      pattern:
                                                                        /^([1-9]\d*)$/,
                                                                      message:
                                                                        "请输入正整数",
                                                                      trigger:
                                                                        "blur",
                                                                    },
                                                                  ],
                                                                  "label-width":
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.is_card_disabled ||
                                                                      String(
                                                                        inner
                                                                          .row
                                                                          .summary_lock_num
                                                                      ) === "1",
                                                                    placeholder:
                                                                      "请输入",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateFeeNumber(
                                                                          scope.$index
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      inner.row
                                                                        .make_count,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          inner.row,
                                                                          "make_count",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "inner.row.make_count",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "寄送地址",
                                                    "min-width": "240",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (inner) {
                                                          return [
                                                            _c(
                                                              "el-form-item",
                                                              {
                                                                staticClass:
                                                                  "cell-form-item",
                                                                attrs: {
                                                                  prop:
                                                                    "material_arr." +
                                                                    scope.$index +
                                                                    ".branch_office_data." +
                                                                    inner.$index +
                                                                    ".address",
                                                                  rules:
                                                                    _vm
                                                                      .printInfo
                                                                      .print_type ===
                                                                    "1"
                                                                      ? {
                                                                          required: true,
                                                                          message:
                                                                            "请输入寄送地址",
                                                                          trigger:
                                                                            "blur",
                                                                        }
                                                                      : {},
                                                                  "label-width":
                                                                    "0",
                                                                },
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    type: "textarea",
                                                                    autosize: {
                                                                      minRows: 2,
                                                                      maxRows: 4,
                                                                    },
                                                                    placeholder:
                                                                      "选择分公司后自动带出",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      inner.row
                                                                        .address,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          inner.row,
                                                                          "address",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "inner.row.address",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm.printInfo.print_type ===
                                                  "1" && !_vm.is_card_disabled
                                                  ? _c("el-table-column", {
                                                      attrs: {
                                                        label: "操作",
                                                        width: "80",
                                                        align: "center",
                                                        fixed: "right",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (
                                                              inner
                                                            ) {
                                                              return [
                                                                String(
                                                                  inner.row
                                                                    .from_summary
                                                                ) !== "1"
                                                                  ? _c(
                                                                      "el-button",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "red",
                                                                          },
                                                                        attrs: {
                                                                          type: "text",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.delMaterialBranch(
                                                                                scope.$index,
                                                                                inner.$index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " 删除 "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "物料预览图",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.pre_img
                                      ? _c("el-image", {
                                          staticStyle: {
                                            height: "50px",
                                            width: "70px",
                                          },
                                          attrs: {
                                            src: scope.row.pre_img,
                                            "preview-src-list": [
                                              scope.row.pre_img,
                                            ],
                                            fit: "contain",
                                          },
                                        })
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "material_type_des",
                              label: "物料类型",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "物料名称",
                              "min-width": "120",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "material_id",
                              label: "物料编码",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "craft_type_des",
                              label: "工艺材质",
                              "min-width": "140",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.printInfo.print_type === "2"
                                      ? [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "cell-form-item",
                                              attrs: {
                                                prop:
                                                  "material_arr." +
                                                  scope.$index +
                                                  ".craft_type",
                                                rules: {
                                                  required: true,
                                                  message: "请选择工艺材质",
                                                  trigger: "change",
                                                },
                                                "label-width": "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "140px",
                                                  },
                                                  attrs: {
                                                    placeholder: "请选择",
                                                    size: "small",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: scope.row.craft_type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "craft_type",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.craft_type",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type ===
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type === '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "1",
                                                      label: "磨砂",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type ===
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type === '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "11",
                                                      label: "磨砂+磁条",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type ===
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type === '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "2",
                                                      label: "光亮",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type ===
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type === '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "10",
                                                      label: "光亮+磨砂",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "3",
                                                      label: "铜版纸",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "4",
                                                      label: "特种纸",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "5",
                                                      label: "无纺布",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "6",
                                                      label: "瓦楞纸",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "7",
                                                      label: "牛皮纸板",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "8",
                                                      label: "聚乙烯",
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .material_type !==
                                                          "1",
                                                        expression:
                                                          "scope.row.material_type !== '1'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      value: "9",
                                                      label: "其他",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.craft_type_des || "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "规格", "min-width": "250" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.printInfo.print_type === "2"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                gap: "8px",
                                              },
                                            },
                                            [
                                              scope.row.attribute_type !== "1"
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "cell-form-item",
                                                      attrs: {
                                                        prop:
                                                          "material_arr." +
                                                          scope.$index +
                                                          ".attribute",
                                                        rules: {
                                                          required: true,
                                                          message: "请选择规格",
                                                          trigger: "change",
                                                        },
                                                        "label-width": "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "160px",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            size: "small",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .attribute,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "attribute",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.attribute",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                  "1",
                                                                expression:
                                                                  "scope.row.material_type === '1'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "1",
                                                              label:
                                                                "8.4*5.4*0.84cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                  "1",
                                                                expression:
                                                                  "scope.row.material_type === '1'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "12",
                                                              label:
                                                                "8.4*5.4*0.76cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "3" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '3' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "2",
                                                              label: "10cm*6cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "3",
                                                              label:
                                                                "10cm*17cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "2" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '2' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "4",
                                                              label: "12cm*6cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "4" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '4' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "5",
                                                              label:
                                                                "13.5cm*7cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "6",
                                                              label:
                                                                "14cm*14cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "2" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '2' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "7",
                                                              label:
                                                                "17cm*9.5cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                    "6" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "7" ||
                                                                  scope.row
                                                                    .material_type ===
                                                                    "8",
                                                                expression:
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '6' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '7' ||\n\t\t\t\t\t\t\t\t\t\t\t\tscope.row.material_type === '8'\n\t\t\t\t\t\t\t\t\t\t\t",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "8",
                                                              label:
                                                                "21cm*21cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                  "2",
                                                                expression:
                                                                  "scope.row.material_type === '2'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "9",
                                                              label:
                                                                "17cm*19cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                  "4",
                                                                expression:
                                                                  "scope.row.material_type === '4'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "10",
                                                              label:
                                                                "18.6cm*10cm",
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  scope.row
                                                                    .material_type ===
                                                                  "5",
                                                                expression:
                                                                  "scope.row.material_type === '5'",
                                                              },
                                                            ],
                                                            attrs: {
                                                              value: "11",
                                                              label:
                                                                "35cm*21cm",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-checkbox",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "4px",
                                                  },
                                                  attrs: {
                                                    "true-label": "1",
                                                    "false-label": "0",
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.attribute_type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "attribute_type",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.attribute_type",
                                                  },
                                                },
                                                [_vm._v("自定义规格")]
                                              ),
                                            ],
                                            1
                                          ),
                                          scope.row.attribute_type === "1"
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "8px",
                                                    "margin-top": "6px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "cell-form-item",
                                                      attrs: {
                                                        prop:
                                                          "material_arr." +
                                                          scope.$index +
                                                          ".attribute_height",
                                                        rules: {
                                                          required: true,
                                                          message: "请输入长",
                                                          trigger: "blur",
                                                        },
                                                        "label-width": "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "100px",
                                                          },
                                                          attrs: {
                                                            size: "small",
                                                            placeholder: "长",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .attribute_height,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "attribute_height",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.attribute_height",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [_vm._v("cm")]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass:
                                                        "cell-form-item",
                                                      attrs: {
                                                        prop:
                                                          "material_arr." +
                                                          scope.$index +
                                                          ".attribute_width",
                                                        rules: {
                                                          required: true,
                                                          message: "请输入宽",
                                                          trigger: "blur",
                                                        },
                                                        "label-width": "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          staticStyle: {
                                                            width: "100px",
                                                          },
                                                          attrs: {
                                                            size: "small",
                                                            placeholder: "宽",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .attribute_width,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "attribute_width",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.attribute_width",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [_vm._v("cm")]
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.attribute_str || "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "设计稿", "min-width": "170" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "cell-form-item",
                                        attrs: {
                                          prop:
                                            "material_arr." +
                                            scope.$index +
                                            ".design_img",
                                          rules:
                                            _vm.printInfo.print_type === "2"
                                              ? [
                                                  {
                                                    validator:
                                                      _vm.validateDesignImg,
                                                    trigger: "change",
                                                  },
                                                ]
                                              : [],
                                          "label-width": "0",
                                        },
                                      },
                                      [
                                        scope.row.design_img &&
                                        scope.row.design_img.length > 0
                                          ? [
                                              _vm.getFirstImage(
                                                scope.row.design_img
                                              )
                                                ? [
                                                    _c("el-image", {
                                                      staticStyle: {
                                                        height: "50px",
                                                        width: "70px",
                                                      },
                                                      attrs: {
                                                        "preview-src-list":
                                                          _vm.getImageList(
                                                            scope.row.design_img
                                                          ),
                                                        src: _vm.getFirstImage(
                                                          scope.row.design_img
                                                        ),
                                                        fit: "contain",
                                                      },
                                                    }),
                                                  ]
                                                : [
                                                    _vm.isPDF(
                                                      scope.row.design_img[0]
                                                    )
                                                      ? [
                                                          _c("img", {
                                                            staticStyle: {
                                                              height: "70px",
                                                              width: "50px",
                                                            },
                                                            attrs: {
                                                              src: require("../../icons/svg/pdf.png"),
                                                            },
                                                          }),
                                                        ]
                                                      : _vm.isAI(
                                                          scope.row
                                                            .design_img[0]
                                                        )
                                                      ? [
                                                          _c("img", {
                                                            staticStyle: {
                                                              height: "70px",
                                                              width: "50px",
                                                            },
                                                            attrs: {
                                                              src: require("../../icons/svg/ai.png"),
                                                            },
                                                          }),
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            staticStyle: {
                                                              height: "70px",
                                                              width: "50px",
                                                            },
                                                            attrs: {
                                                              src: require("../../icons/svg/icon_psd.png"),
                                                            },
                                                          }),
                                                        ],
                                                  ],
                                            ]
                                          : _vm._e(),
                                        scope.row.design_img &&
                                        scope.row.design_img.length > 0
                                          ? _c("div", [
                                              _vm._v(
                                                " 共上传" +
                                                  _vm._s(
                                                    scope.row.design_img.length
                                                  ) +
                                                  "张设计稿 "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.printInfo.print_type === "2"
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.uploadFile(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("上传设计稿")]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          !_vm.material_apply__disabled
                            ? _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "80",
                                  align: "center",
                                  fixed: "right",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmRemoveRow(
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 移除 ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  226475264
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("费用信息"),
                  ]),
                ]
              ),
              !_vm.material_arr || _vm.material_arr.length === 0
                ? _c("div", { staticClass: "emptyTip" }, [
                    _vm._v(" 暂无费用信息 "),
                  ])
                : _c(
                    "el-form",
                    {
                      ref: "feeForm",
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        model: _vm.fee_info,
                        "label-position": "right",
                        "label-width": "150px",
                      },
                    },
                    [
                      _vm._l(
                        _vm.fee_info.material_money,
                        function (item, index) {
                          return _c(
                            "el-row",
                            { key: item.material_id, attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label:
                                          item.material_type_des + "印刷单价：",
                                        prop:
                                          "material_money." + index + ".price",
                                        rules: _vm.feeRules.price,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onFeePriceInput(item)
                                            },
                                          },
                                          model: {
                                            value: item.price,
                                            callback: function ($$v) {
                                              _vm.$set(item, "price", $$v)
                                            },
                                            expression: "item.price",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "数量：",
                                        prop:
                                          "material_money." + index + ".number",
                                        rules: _vm.feeRules.number,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onFeeNumberInput(item)
                                            },
                                          },
                                          model: {
                                            value: item.number,
                                            callback: function ($$v) {
                                              _vm.$set(item, "number", $$v)
                                            },
                                            expression: "item.number",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("件"),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "印刷费用：",
                                        prop:
                                          "material_money." +
                                          index +
                                          ".print_money",
                                        rules: _vm.feeRules.print_money,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onFeePrintMoneyInput(
                                                item
                                              )
                                            },
                                          },
                                          model: {
                                            value: item.print_money,
                                            callback: function ($$v) {
                                              _vm.$set(item, "print_money", $$v)
                                            },
                                            expression: "item.print_money",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "印刷费用合计：",
                                    prop: "print_money",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "自动计算",
                                        size: "small",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.fee_info.print_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "print_money",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.print_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "快递运费：",
                                    prop: "express_fee",
                                    rules: _vm.feeRules.money,
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onFeeMoneyInput(
                                            "express_fee"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fee_info.express_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "express_fee",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.express_fee",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "印刷费用（含运费）：",
                                    prop: "total_money",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "自动计算",
                                        size: "small",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.fee_info.total_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "total_money",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.total_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "公司承担费用：",
                                    prop: "company_money",
                                    rules: _vm.feeRules.money,
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onFeeMoneyInput(
                                            "company_money"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fee_info.company_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "company_money",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.company_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "销售承担费用：",
                                    prop: "person_money",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "自动计算",
                                        size: "small",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.fee_info.person_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "person_money",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.person_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "优惠金额：",
                                    prop: "coupon_cost",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "请输入",
                                        size: "small",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onFeeMoneyInput(
                                            "coupon_cost"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fee_info.coupon_cost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "coupon_cost",
                                            $$v
                                          )
                                        },
                                        expression: "fee_info.coupon_cost",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "应付供应商金额：",
                                    prop: "real_supplier_money",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        placeholder: "自动计算",
                                        size: "small",
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.fee_info.real_supplier_money,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fee_info,
                                            "real_supplier_money",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "fee_info.real_supplier_money",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("元"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("状态&备注"),
                  ]),
                ]
              ),
              _c(
                "el-form",
                {
                  ref: "stateForm",
                  attrs: { model: _vm.state_info, "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "制作状态",
                        prop: "make_status",
                        rules: [
                          {
                            required: true,
                            trigger: "change",
                            message: "请选择制作状态",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.state_info.make_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.state_info, "make_status", $$v)
                            },
                            expression: "state_info.make_status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("设计中"),
                          ]),
                          _c("el-radio", { attrs: { label: "0" } }, [
                            _vm._v("待完善"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("印刷中"),
                          ]),
                          _c("el-radio", { attrs: { label: "3" } }, [
                            _vm._v("已完成"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.drawerParams.type === "edit"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "结算状态",
                            prop: "settlement_status",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择结算状态",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.state_info.settlement_status,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.state_info,
                                    "settlement_status",
                                    $$v
                                  )
                                },
                                expression: "state_info.settlement_status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("未结算"),
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("待结算"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("已结算"),
                              ]),
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v("待付款"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.drawerParams.type === "edit"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "有效/无效",
                            prop: "status",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择有效状态",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.state_info.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.state_info, "status", $$v)
                                },
                                expression: "state_info.status",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("有效"),
                              ]),
                              _c("el-radio", { attrs: { label: "0" } }, [
                                _vm._v("无效"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "note" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "560px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入内容",
                          maxlength: "100",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 10 },
                        },
                        model: {
                          value: _vm.state_info.note,
                          callback: function ($$v) {
                            _vm.$set(_vm.state_info, "note", $$v)
                          },
                          expression: "state_info.note",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("日志"),
                  ]),
                ]
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    "header-cell-style": {
                      background: "#F1F1F1",
                      color: "#333333",
                    },
                    data: _vm.logList,
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "操作人",
                      prop: "nick_name",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作类型",
                      prop: "operate_des",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", align: "left" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(scope.row.des) },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作时间",
                      prop: "create_time",
                      align: "left",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "text-align": "right", margin: "20px 0" } },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, prev, pager, next, jumper",
                      "page-size": 20,
                      total: _vm.pages.totalCount,
                      "current-page": _vm.pages.currentPage,
                    },
                    on: { "current-change": _vm.currentChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "footer-btns" },
        [
          _vm.from !== "details"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("返回")]),
        ],
        1
      ),
      _c("AddMaterialDialog", {
        ref: "AddMaterialDialog",
        attrs: {
          visible: _vm.addMaterialDialog.visible,
          "add-material-params": _vm.addMaterialParams,
          "existing-material-ids": _vm.existingMaterialIds,
        },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.addMaterialDialog, "visible", $event)
          },
          submit: _vm.handleAddMaterialSubmit,
        },
      }),
      _c("printing-upload-dialog", {
        ref: "printingUploadDialog",
        on: { emitGet: _vm.emitGetMaterial },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "80%",
            title: _vm.drawerTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
              projectType: _vm.selectedProjectType,
              projectStatus: _vm.selectedProjectStatus,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }